<form (submit)="submit($event)" [formGroup]="formGroup">
  <div class="pb-6 flex flex-col gap-6">
    <zaeper-input-text [inputOptions]="nameInputTextOptions"></zaeper-input-text>
    @if (!formGroup.controls['name'].untouched &&
    formGroup.controls['name'].invalid) {
      <ul>
        @if (formGroup.controls['name'].errors?.['required']) {
          <li>
            <small
              class="text-zaeper-error-500"
            >{{ "validation-required" | zDictionary: "forms" }}</small
            >
          </li>
        }

        @if (formGroup.controls['name'].errors?.['minlength']) {
          <li>
            <small
              class="text-zaeper-error-500"
            >{{ "validation-min-length" | zDictionary: "forms" }}</small
            >
          </li>
        }
      </ul>
    }

    <zaeper-input-text [inputOptions]="identifierInputTextOptions"></zaeper-input-text>
    @if (!formGroup.controls['identifier'].untouched &&
    formGroup.controls['identifier'].invalid) {
      <ul>
        @if (formGroup.controls['identifier'].errors?.['minlength'] ||
        formGroup.controls['identifier'].errors?.['maxlength']) {
          <li>
            <small class="text-zaeper-error-500"
            >Identifier must be between 2 and 63 characters</small>
          </li>
        }
        @if (formGroup.controls['identifier'].errors?.['pattern']) {
          <li>
            <small class="text-zaeper-error-500"
            >Lowercase alphanumeric and hyphens only (e.g. my-widget)</small>
          </li>
        }
      </ul>
    }

    <div class="flex items-start gap-3">
      <p-checkbox formControlName="systemApp"
                  [binary]="true"
                  inputId="system-app" />
      <label for="system-app">System app (Zaeper-built, not third-party)</label>
    </div>
  </div>
  <div class="w-full flex gap-2 justify-end">
    <p-button (onClick)="close()" [rounded]="true" [outlined]="true">Abrechen</p-button>
    <p-button [rounded]="true" type="submit">Erstellen</p-button>
  </div>
</form>
